<template>
    <div class="mb-3 row d-flex justify-content-between">
        <div class="col col-12 display-4" :class="noright ? '' : 'col-md-9'">
            <slot></slot>
        </div>
        <div class="col col-12 col-md-3 text-right" v-if="!noright">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['loading', 'noright']
}
</script>